import {Component, createRef, useEffect, useState} from "react";
import classes from "./Archives.module.css";
import moment from "moment";
import { getDatabase, ref, get, child } from 'firebase/database';

const capitalize = s => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
};

const ArchiveItem = props => {
    const [patientType, setPatientType] = useState({});
    var selected = props.selectedArchive === props.conversationID ? true : false;
    var name = props.patientName !== undefined ? capitalize(props.patientName) : "Patient";
    var email = props.patientEmail !== undefined ? `(${props.patientEmail})` : "";
    var adminDoctor = props.adminDoctor!==undefined?`(${props.adminDoctor})` :"";
    const [chatType, setChatType] = useState("");
    useEffect(() => {
        if (props?.archiveData){
            if (props?.archiveData?.isEMRChat) {
                if (props?.archiveData?.referralFromApp) {
                    setChatType("Free Chat");
                }else {
                    setChatType("Health Card");
                }
            }else if(props?.archiveData?.subscriptionType === "quarterly"){
                setChatType("Quarterly Plan User");
            } else if(props?.archiveData?.subscriptionType === "yearly"){
                setChatType("Yearly Plan User");
            }else if(props?.archiveData?.subscriptionType === "monthly"){
                setChatType("Monthly Plan User");
            } else if(props?.archiveData?.partner_id ===7){
                setChatType("Orchyd Patient");
            } else if(props?.archiveData?.isPhysioPatient){
                setChatType("Physio Patient");
            }else if(props?.archiveData?.payAfterChat){
                setChatType(`Trial plan user${props?.archiveData?.paymentCompleted ? " - Paid" : props?.archiveData?.checkoutSessionID ? " - Unpaid" : ""}`);
            }else if(props?.archiveData?.doNotCharge){
                if(props.archiveData?.fromConsumable){
                    if (props.archiveData?.freePrescription && props.archiveData?.freeMedicalNote){
                        setChatType("Free prescriptions & notes");
                    } else if (props.archiveData?.freePrescription){
                        setChatType("Free Prescription");
                    } else if (props.archiveData?.freeMedicalNote){
                        setChatType("Free Medical Note");
                    }else{
                        setChatType("Free Prescription");
                    }
                }else{
                    setChatType("Free Prescription");
                }
            } else{
                setChatType("Private Pay");
            }
        }

    }, [props?.archiveData]);
    return (
        <div
            className={selected ? classes.selected_list_view : classes.arc_list_view}
            onClick={() => props.onArchiveItemClick(props.archiveData)}
        >   
            <div className={classes.list_img_style}>
                <div className={classes.selected_list_img}>
                    <span className={classes.selected_user_img}>{name.charAt(0)}</span>
                </div>
            </div>
            <div className={classes.list_item}>
                <div className={selected ? classes.selected_item_name : classes.patient_name}>{name}</div>
                <div className={selected ? classes.selected_item_name : classes.item_name}>{email}</div>
                <div className={selected ? classes.selected_item_name : classes.item_name}>
                    {props.doctorName} 
                </div>
                <div>{adminDoctor || ""}</div>

                <div className={selected ? classes.item_payment_status : classes.item_payment_status}>{chatType}</div>
                {/*<div className={selected ? classes.selected_item_name : classes.item_name}>*/}
                {/*    <span> {patientType} </span>*/}
                {/*</div>*/}
                <div className={selected ? classes.selected_item_name : classes.item_name}>
                    <span>{name.charAt(0)}: </span>
                    Hello Doctor! My name is {name}.
                </div>
            </div>
            {!selected && (
                <div className={classes.list_item_second}>
                    <div>
                        <div className={classes.time_style}>
                            {moment(props.timestamp).format("YYYY-MM-DD hh:mm:ss")}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default class ArchiveList extends Component {
    constructor(props) {
        
        super(props);
        this.state = {
            selectedArchive: null,
            archiveSetState: 0,
            filterDate: "", 
            filterPca: "all",
            doctorList: [],
            doctorSearchTerm: "",
            showDoctorDropdown: false,
            startDate: "",
            endDate: "",
            showFilters: false,
            activeFilters: "", // Store active filter string for pagination
            // New filter states
            filterAdminDoctor: "",
            adminDoctorList: [],
            adminDoctorSearchTerm: "",
            showAdminDoctorDropdown: false,
            filterCountry: "",
            filterPatientID: "",
            filterChatSessionID: "",
            filterEmail: "",
            filterHealthCard: "",
            filterInteractionType: "all",
            filterChatType: "all"
        };
        this.filterButtonRef = createRef();
        this.wrapperRef = createRef();
        this.searchInputRef = createRef();
    }

    componentDidMount() {
        // Get database reference from Firebase
        const db = getDatabase();
        const doctorsRef = ref(db, 'doctors');
        
        get(doctorsRef).then((snapshot) => {
            const doctorsData = snapshot.val() || {};
            const doctorList = Object.values(doctorsData)
                .filter(doc => doc.role === "Doctor" || doc.role === "Physio" || doc.role === "Nutritionist")
                .map(doc => ({
                    id: doc.firebaseID,
                    name: doc.doctorName
                }));
            this.setState({ doctorList });
        }).catch((error) => {
            console.error("Error fetching doctors:", error);
        });

        // Fetch admin doctors from medicalDirective/Canada
        const adminDoctorsRef = ref(db, 'medicalDirective/Canada');
        
        get(adminDoctorsRef).then((snapshot) => {
            const adminDoctorsData = snapshot.val() || {};
            const adminDoctorList = Object.values(adminDoctorsData)
                .map(doc => ({
                    id: doc.firebaseID || doc.doctorID,
                    name: doc.name
                }))
                .filter(doc => doc.name); // Filter out entries without names
            this.setState({ adminDoctorList });
        }).catch((error) => {
            console.error("Error fetching admin doctors:", error);
        });

        // Add click outside handler - using 'click' instead of 'mousedown' 
        // to allow dropdown onMouseDown to fire first
        document.addEventListener('click', this.handleClickOutside);
   }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target) && 
            this.filterButtonRef.current && !this.filterButtonRef.current.contains(event.target)) {
            this.setState({ showFilters: false });
        }
    };

    onArchiveItemClick = data => {
        const {
            user_id,
            patientEmail,
            patientName,
            doctorName,
            doctorID,
            patientID,
            doctorImage,
            conversationID,
            tagsList,
            city,
            country,
            platform,
            DOB,
            gender,
            issue,
            currentMedications,
            diagnosisValue,
            opinionDescriptionValue,
            commentAdded,
            medications,
            followUpData,
            gmtOffset,
            buildNumber,
            convoCount,
            averageSleep,
            currentSleep,
            heartRate,
            heightCm,
            heightFeet,
            stepCount,
            runningWalking,
            weightKg,
            weightLbs,
            periodStartDate,
            flowType,
            restingHeartRate,
            complete_address,
            timestamp,
            issueResolved,
            symptoms,
            findings,
            assessment,
            plan,
            ownerProfile,
            owner
        } = data;

        this.setState({selectedArchive: conversationID});
        this.props.archiveHeaderItem(
            user_id,
            patientEmail,
            patientName,
            doctorName,
            doctorID,
            patientID,
            doctorImage,
            conversationID,
            tagsList,
            city,
            country,
            platform,
            DOB,
            gender,
            issue,
            currentMedications,
            diagnosisValue,
            opinionDescriptionValue,
            commentAdded,
            medications,
            followUpData,
            gmtOffset,
            buildNumber,
            convoCount,
            averageSleep,
            currentSleep,
            heartRate,
            heightCm,
            heightFeet,
            stepCount,
            runningWalking,
            weightKg,
            weightLbs,
            periodStartDate,
            flowType,
            restingHeartRate,
            complete_address,
            timestamp,
            issueResolved,
            symptoms,
            findings,
            assessment,
            plan,
            ownerProfile,
            owner
        );
    };

    archiveDefault = () => {
        if (this.props.archives[0]) {
            const {
                user_id,
                patientEmail,
                patientName,
                doctorName,
                doctorID,
                patientID,
                doctorImage,
                conversationID,
                tagsList,
                city,
                country,
                platform,
                DOB,
                gender,
                issue,
                currentMedications,
                diagnosisValue,
                opinionDescriptionValue,
                commentAdded,
                medications,
                followUpData,
                gmtOffset,
                buildNumber,
                convoCount,
                averageSleep,
                currentSleep,
                heartRate,
                heightCm,
                heightFeet,
                stepCount,
                runningWalking,
                weightKg,
                weightLbs,
                periodStartDate,
                flowType,
                restingHeartRate,
                complete_address,
                timestamp,
                issueResolved,
                symptoms,
                findings,
                assessment,
                plan,
                ownerProfile,
                owner
            } = this.props.archives[0];

            this.setState({selectedArchive: conversationID});
            this.props.archiveHeaderItem(
                user_id,
                patientEmail,
                patientName,
                doctorName,
                doctorID,
                patientID,
                doctorImage,
                conversationID,
                tagsList,
                city,
                country,
                platform,
                DOB,
                gender,
                issue,
                currentMedications,
                diagnosisValue,
                opinionDescriptionValue,
                commentAdded,
                medications,
                followUpData,
                gmtOffset,
                buildNumber,
                convoCount,
                averageSleep,
                currentSleep,
                heartRate,
                heightCm,
                heightFeet,
                stepCount,
                runningWalking,
                weightKg,
                weightLbs,
                periodStartDate,
                flowType,
                restingHeartRate,
                complete_address,
                timestamp,
                issueResolved,
                symptoms,
                findings,
                assessment,
                plan,
                ownerProfile,
                owner
            );
        }
    };

    UNSAFE_componentWillReceiveProps(newProps) {
        if (
            Boolean(newProps.archives) &&
            Boolean(newProps.archives[0]) &&
            this.state.archiveSetState !== 1
        ) {
            const {
                user_id,
                patientEmail,
                patientName,
                doctorName,
                doctorID,
                patientID,
                doctorImage,
                conversationID,
                tagsList,
                city,
                country,
                platform,
                DOB,
                gender,
                issue,
                currentMedications,
                diagnosisValue,
                opinionDescriptionValue,
                commentAdded,
                medications,
                followUpData,
                gmtOffset,
                buildNumber,
                convoCount,
                averageSleep,
                currentSleep,
                heartRate,
                heightCm,
                heightFeet,
                stepCount,
                runningWalking,
                weightKg,
                weightLbs,
                periodStartDate,
                flowType,
                restingHeartRate,
                complete_address,
                timestamp,
                issueResolved,
                symptoms,
                findings,
                assessment,
                plan
            } = newProps.archives[0];

            this.setState({selectedArchive: newProps.archives[0].conversationID, archiveSetState: 1});

            this.props.archiveHeaderItem(
                user_id,
                patientEmail,
                patientName,
                doctorName,
                doctorID,
                patientID,
                doctorImage,
                conversationID,
                tagsList,
                city,
                country,
                platform,
                DOB,
                gender,
                issue,
                currentMedications,
                diagnosisValue,
                opinionDescriptionValue,
                commentAdded,
                medications,
                followUpData,
                gmtOffset,
                buildNumber,
                convoCount,
                averageSleep,
                currentSleep,
                heartRate,
                heightCm,
                heightFeet,
                stepCount,
                runningWalking,
                weightKg,
                weightLbs,
                periodStartDate,
                flowType,
                restingHeartRate,
                complete_address,
                timestamp,
                issueResolved,
                symptoms,
                findings,
                assessment,
                plan
            );
        }
    }

    componentDidUpdate() {
        // Disable auto-scroll when filtering is active to avoid ref errors
        if (this.state.filterPca !== "all" || this.state.startDate || this.state.endDate || this.state.filterDate) {
            return;
        }

        if (Boolean(this.props.previous_length) && !this.props.isSearch) {
            const refKey = `myrefRow ${this.props.archives[this.props.previous_length]?.conversationID}`;
            if (
                this.props.previous_length !== this.props.archives.length - 1 &&
                this[refKey] &&
                this[refKey].current
            ) {
                this[refKey].current.scrollIntoView({block: "start"});
            }
        }
    }

    archiveSearchValue = event => {
        this.props.archiveSearchValue(event.target.value);
    };
    
    archiveSearchText = event => {
        this.props.archiveSearchText();
    };

    handleDoctorSearch = (e) => {
        this.setState({ 
            doctorSearchTerm: e.target.value,
            showDoctorDropdown: true 
        });
    };

    handleDoctorSelect = (doctorName) => {
        this.setState({ 
            filterPca: doctorName,
            doctorSearchTerm: doctorName,
            showDoctorDropdown: false 
        });
    };

    clearDoctorFilter = (e) => {
        if (e) e.stopPropagation();
        this.setState({ 
            filterPca: "all",
            doctorSearchTerm: "",
            showDoctorDropdown: false 
        });
    };

    handleAdminDoctorSearch = (e) => {
        this.setState({ 
            adminDoctorSearchTerm: e.target.value,
            showAdminDoctorDropdown: true 
        });
    };

    handleAdminDoctorSelect = (doctorName) => {
        this.setState({ 
            filterAdminDoctor: doctorName,
            adminDoctorSearchTerm: doctorName,
            showAdminDoctorDropdown: false 
        });
    };

    clearAdminDoctorFilter = (e) => {
        if (e) e.stopPropagation();
        this.setState({ 
            filterAdminDoctor: "",
            adminDoctorSearchTerm: "",
            showAdminDoctorDropdown: false 
        });
    };

    handleDateChange = (field, value) => {
        this.setState({ [field]: value, filterDate: "" });
    };

    clearDateRange = () => {
        this.setState({ startDate: "", endDate: "", filterDate: "" }, () => {
            this.applyFilters();
        });
    };

    handleFilterChange = (field, value) => {
        this.setState({ [field]: value });
    };

    buildFilterString = () => {
        const { 
            filterPca, 
            startDate, 
            endDate,
            filterAdminDoctor,
            filterCountry,
            filterPatientID,
            filterChatSessionID,
            filterEmail,
            filterHealthCard,
            filterInteractionType,
            filterChatType
        } = this.state;
        
        console.log('[ArchiveList] Building filter string with:', {
            filterPca, startDate, endDate, filterAdminDoctor, filterCountry,
            filterPatientID, filterChatSessionID, filterEmail, filterHealthCard,
            filterInteractionType, filterChatType
        });
        
        let filters = [];

        // Doctor filter
        if (filterPca !== "all") {
            filters.push(`doctorName:"${filterPca}"`);
        }

        // Date range filter
        if (startDate && endDate) {
            const startTime = Math.floor(moment(startDate).startOf('day').valueOf());
            const endTime = Math.floor(moment(endDate).endOf('day').valueOf());
            filters.push(`timestamp>=${startTime}`);
            filters.push(`timestamp<=${endTime}`);
        }

        // Admin Doctor filter
        if (filterAdminDoctor) {
            filters.push(`adminDoctor:"${filterAdminDoctor.trim()}"`);
        }

        // Country filter
        if (filterCountry) {
            filters.push(`country:"${filterCountry.trim()}"`);
        }

        // Patient ID filter
        if (filterPatientID) {
            filters.push(`patientID:"${filterPatientID.trim()}"`);
        }

        // Chat Session ID filter
        if (filterChatSessionID) {
            filters.push(`conversationID:"${filterChatSessionID.trim()}"`);
        }

        // Email filter (replaces Address)
        if (filterEmail) {
            filters.push(`patientEmail:"${filterEmail.trim()}"`);
        }

        // Health Card Number filter
        if (filterHealthCard) {
            filters.push(`healthInsuranceCardNumber:"${filterHealthCard.trim()}"`);
        }

        // Interaction Type filter
        if (filterInteractionType !== "all") {
            filters.push(`issueResolved:"${filterInteractionType}"`);
        }

        // Chat Type filter (isPhysioPatient)
        if (filterChatType === "physio") {
            filters.push(`isPhysioPatient:true`);
        } else if (filterChatType === "family") {
            filters.push(`NOT isPhysioPatient:true`);
        }

        return filters.join(' AND ');
    };

    applyFilters = () => {
        const filters = this.buildFilterString();
        console.log('[ArchiveList] Applying filters:', filters);
        this.setState({ activeFilters: filters });
        // Clear the search input when applying filters
        if (this.searchInputRef.current) {
            this.searchInputRef.current.value = '';
        }
        // Clear the search input value in parent to avoid conflicts
        this.props.archiveSearchValue('');
        
        // Only apply filters if there's actually a filter string
        if (filters && filters.length > 0) {
            console.log('[ArchiveList] Calling archiveSearchText with filters');
            this.props.archiveSearchText(null, filters);
        } else {
            console.log('[ArchiveList] No filters to apply, loading default archives');
            // If no filters, just reload the default archives
            this.props.archiveSearchText(null, "");
        }
    };

    clearAllFilters = () => {
        this.setState({
            filterPca: "all",
            doctorSearchTerm: "",
            startDate: "",
            endDate: "",
            filterDate: "",
            filterAdminDoctor: "",
            adminDoctorSearchTerm: "",
            filterCountry: "",
            filterPatientID: "",
            filterChatSessionID: "",
            filterEmail: "",
            filterHealthCard: "",
            filterInteractionType: "all",
            filterChatType: "all",
            activeFilters: ""
        }, () => {
            // Clear the search input as well
            if (this.searchInputRef.current) {
                this.searchInputRef.current.value = '';
            }
            // Clear search input value in parent
            this.props.archiveSearchValue('');
            // Reload default archives
            this.props.archiveSearchText(null, "");
        });
    };

    render() {
        var archivesList = [];
        let filteredArchives = this.props.archives || [];

        // Get filtered doctor list based on search term
        const filteredDoctorList = this.state.doctorList.filter(doc =>
            doc.name.toLowerCase().includes(this.state.doctorSearchTerm.toLowerCase())
        );

        // Get filtered admin doctor list based on search term
        const filteredAdminDoctorList = this.state.adminDoctorList.filter(doc =>
            doc.name.toLowerCase().includes(this.state.adminDoctorSearchTerm.toLowerCase())
        );

        if (Boolean(this.props.archives)) {
            archivesList = filteredArchives.map((archive, index) => {
                // Use unique key for ref instead of filtered index
                let ref = `myrefRow ${archive.conversationID}`;
                this[ref] = createRef();
                return (
                    <ArchiveItem
                        key={archive.conversationID}
                        patientName={archive.ownerProfile?.name || archive.patientName}
                        doctorName={archive.doctorName}
                        conversationID={archive.conversationID}
                        doctorImage={archive.doctorProfileImg}
                        doctorID={archive.doctorID}
                        timestamp={archive.timestamp}
                        adminDoctor={archive.adminDoctor||""}
                        archiveData={archive}
                        patientEmail={archive.patientEmail}
                        tagsList={archive.tagsList !== undefined ? archive.tagsList : []}
                        onArchiveItemClick={data => this.onArchiveItemClick(data)}
                        selectedArchive={this.state.selectedArchive}
                        nextref={this[ref]}
                    />
                );
            });
        }

        const hasActiveFilters = this.state.startDate || this.state.endDate || this.state.filterDate || 
            this.state.filterPca !== "all" || this.state.filterAdminDoctor || this.state.filterCountry ||
            this.state.filterPatientID || this.state.filterChatSessionID || this.state.filterEmail || this.state.filterHealthCard ||
            this.state.filterInteractionType !== "all" || this.state.filterChatType !== "all";

        return (
            <div className={classes.list_view}>
                <div className={classes.block}>
                    <div className={classes.block}>
                        <div className={classes.main_block}>
                            <div className={classes.list_body_view}>
                                <div className={classes.list_body_main}>
                                    <div className={classes.search_box}>
                                        <div className={classes.search_box_section}>
                                            <div className={classes.input_view}>
                                                <input
                                                    ref={this.searchInputRef}
                                                    placeholder="Press enter to search in archives"
                                                    className={classes.input_style}
                                                    onChange={event => this.archiveSearchValue(event)}
                                                    onKeyPress={event => {
                                                        if (event.key === "Enter") {
                                                            this.props.archiveSearchText(event);
                                                        }
                                                    }}
                                                />
                                            </div>
                                       
                                            <div className={classes.search_sub_section} style={{ marginTop: '15px', marginBottom: '10px' }}>
                                                <div className={classes.list_count}>
                                                    {Boolean(this.props.archives) && (
                                                        <div>
                                                            <span>{filteredArchives.length} </span>chats
                                                        </div>
                                                    )}
                                                </div>
                                                <div className={classes.search_button}>
                                                    <div onClick={(event)=>this.props.archiveSearchText(event)}>
                                                        Search
                                                    </div>
                                                    <div onClick={(event)=>this.props.archiveSearchText(event, "chat-id")}>
                                                        Search ID
                                                    </div>
                                                    
                                                    {/* Advanced Filters Toggle Button - Next to search buttons */}
                                                    <div 
                                                        ref={this.filterButtonRef}
                                                        onClick={() => this.setState({ showFilters: !this.state.showFilters })}
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: hasActiveFilters ? '#007bff' : '#f8f9fa',
                                                            color: hasActiveFilters ? 'white' : '#333',
                                                            padding: '9px 3px',
                                                            borderRadius: '4px',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            border: hasActiveFilters ? 'none' : '1px solid #ccc',
                                                            fontWeight: '500',
                                                            transition: 'all 0.2s'
                                                        }}
                                                    >
                                                        <span>More</span>
                                                        <span style={{ 
                                                            fontSize: '12px',
                                                            padding: '2px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                         }}>
                                                            {this.state.showFilters ? '▲' : '▼'}
                                                        </span>
                                                        {/* {hasActiveFilters && (
                                                            <span style={{
                                                                backgroundColor: 'rgba(255,255,255,0.3)',
                                                                borderRadius: '4px',
                                                                padding: '9px 3px',
                                                                fontSize: '12px'
                                                            }}>
                                                                Active
                                                            </span>
                                                        )} */}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Collapsible Filter Dropdown - Positioned below button */}
                                            <div style={{ position: 'relative' }}>
                                                {this.state.showFilters && (
                                                    <div 
                                                        ref={this.wrapperRef}
                                                        className={classes.filter_section} 
                                                        style={{ 
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: 0,
                                                            display: 'grid',
                                                            gridTemplateColumns: 'repeat(4, minmax(250px, 1fr))',
                                                            gap: '4px', 
                                                            padding: '10px',
                                                            backgroundColor: 'white',
                                                            borderRadius: '8px',
                                                            marginTop: '2px',
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                            zIndex: 1000,
                                                            border: '1px solid #ddd',
                                                            minWidth: '800px',
                                                            maxHeight: '70vh',
                                                            overflowY: 'auto'
                                                        }}>

                                                    {/* Searchable Doctor Filter */}
                                                    <div style={{ position: 'relative' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            PCA
                                                        </label>
                                                        <div style={{ position: 'relative', width: '50%', gap: '8px', display: 'flex' }}>
                                                            <input
                                                                type="text"
                                                                placeholder="Search PCA..."
                                                                className={classes.filter_select}
                                                                value={this.state.doctorSearchTerm}
                                                                onChange={this.handleDoctorSearch}
                                                                onFocus={() => this.setState({ showDoctorDropdown: true })}
                                                                onBlur={() => setTimeout(() => this.setState({ showDoctorDropdown: false }), 200)}
                                                                style={{ 
                                                                    cursor: "text",
                                                                    padding: this.state.filterPca !== "all" 
                                                                        ? "8px 45px 8px 12px"  // Extra right padding when clear button is visible
                                                                        : "8px 8px 8px 12px",
                                                                    border: "1px solid rgb(204, 204, 204)",
                                                                    borderRadius: "4px",
                                                                    fontSize: "14px",
                                                                    backgroundColor: "white",
                                                                    // width: "100%",
                                                                    boxSizing: "border-box",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap"
                                                                }}
                                                            />
                                                            {this.state.filterPca !== "all" && (
                                                                <button
                                                                    onClick={(e) => this.clearDoctorFilter(e)}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        right: '8px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        border: 'none',
                                                                        background: 'transparent',
                                                                        cursor: 'pointer',
                                                                        fontSize: '18px',
                                                                        padding: '0 5px',
                                                                        color: '#666',
                                                                        fontWeight: 'bold'
                                                                    }}
                                                                >
                                                                    ✕
                                                                </button>
                                                            )}
                                                        </div>
                                                        {this.state.showDoctorDropdown && filteredDoctorList.length > 0 && (
                                                            <div 
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 'calc(100% + 4px)',
                                                                    left: 0,
                                                                    right: 0,
                                                                    backgroundColor: 'white',
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '4px',
                                                                    maxHeight: '250px',
                                                                    overflowY: 'auto',
                                                                    zIndex: 1000,
                                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                                                                    marginTop: '4px'
                                                                }}
                                                            >
                                                                <div
                                                                    onMouseDown={() => this.handleDoctorSelect("all")}
                                                                    style={{
                                                                        padding: '10px 12px',
                                                                        cursor: 'pointer',
                                                                        borderBottom: '1px solid #eee',
                                                                        fontWeight: 'bold',
                                                                        backgroundColor: '#f8f9fa'
                                                                    }}
                                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#e9ecef'}
                                                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                                >
                                                                    All Doctors
                                                                </div>
                                                                {filteredDoctorList.map(doc => (
                                                                    <div
                                                                        key={doc.id}
                                                                        onMouseDown={() => this.handleDoctorSelect(doc.name)}
                                                                        style={{
                                                                            padding: '10px 12px',
                                                                            cursor: 'pointer',
                                                                            borderBottom: '1px solid #f0f0f0',
                                                                            fontSize: '14px'
                                                                        }}
                                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                                    >
                                                                        {doc.name}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Admin Doctor Filter - Searchable Dropdown */}
                                                    <div style={{ position: 'relative' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            Admin Doctor
                                                        </label>
                                                        <div style={{ position: 'relative', width: '50%' , gap: '8px', display: 'flex' }}>
                                                            <input
                                                                type="text"
                                                                placeholder="Search admin doctor..."
                                                                className={classes.filter_select}
                                                                value={this.state.adminDoctorSearchTerm}
                                                                onChange={this.handleAdminDoctorSearch}
                                                                onFocus={() => this.setState({ showAdminDoctorDropdown: true })}
                                                                onBlur={() => setTimeout(() => this.setState({ showAdminDoctorDropdown: false }), 200)}
                                                                style={{
                                                                    cursor: "text",
                                                                    padding: this.state.filterAdminDoctor 
                                                                        ? "8px 45px 8px 12px"  // Extra right padding when clear button is visible
                                                                        : "8px 8px 8px 12px",
                                                                    border: "1px solid rgb(204, 204, 204)",
                                                                    borderRadius: "4px",
                                                                    fontSize: "14px",
                                                                    backgroundColor: "white",
                                                                    // width: "100%",
                                                                    boxSizing: "border-box",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap"
                                                                }}
                                                            />
                                                            {this.state.filterAdminDoctor && (
                                                                <button
                                                                    onClick={(e) => this.clearAdminDoctorFilter(e)}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        right: '8px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        border: 'none',
                                                                        background: 'transparent',
                                                                        cursor: 'pointer',
                                                                        fontSize: '18px',
                                                                        padding: '0 5px',
                                                                        color: '#666',
                                                                        fontWeight: 'bold'
                                                                    }}
                                                                >
                                                                    ✕
                                                                </button>
                                                            )}
                                                        </div>
                                                        {this.state.showAdminDoctorDropdown && filteredAdminDoctorList.length > 0 && (
                                                            <div 
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 'calc(100% + 4px)',
                                                                    left: 0,
                                                                    right: 0,
                                                                    backgroundColor: 'white',
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '4px',
                                                                    maxHeight: '250px',
                                                                    overflowY: 'auto',
                                                                    zIndex: 1000,
                                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                                                                    marginTop: '4px'
                                                                }}
                                                            >
                                                                <div
                                                                    onMouseDown={() => this.handleAdminDoctorSelect("")}
                                                                    style={{
                                                                        padding: '10px 12px',
                                                                        cursor: 'pointer',
                                                                        borderBottom: '1px solid #eee',
                                                                        fontWeight: 'bold',
                                                                        backgroundColor: '#f8f9fa'
                                                                    }}
                                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#e9ecef'}
                                                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                                >
                                                                    All Admin Doctors
                                                                </div>
                                                                {filteredAdminDoctorList.map(doc => (
                                                                    <div
                                                                        key={doc.id}
                                                                        onMouseDown={() => this.handleAdminDoctorSelect(doc.name)}
                                                                        style={{
                                                                            padding: '10px 12px',
                                                                            cursor: 'pointer',
                                                                            borderBottom: '1px solid #f0f0f0',
                                                                            fontSize: '14px'
                                                                        }}
                                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                                    >
                                                                        {doc.name}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Country Filter - Changed to input */}
                                                    <div style={{ position: 'relative', width: '50%' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            Country
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter country..."
                                                            className={classes.filter_select}
                                                            value={this.state.filterCountry}
                                                            onChange={(e) => this.handleFilterChange('filterCountry', e.target.value)}
                                                            style={{
                                                                        cursor: "text",
                                                                        padding: "8px 8px 8px 12px",
                                                                        // width: "100%",
                                                                        border: "1px solid rgb(204, 204, 204)",
                                                                        borderRadius: "4px",
                                                                        fontSize: "14px",
                                                                        backgroundColor: "white",
                                                            }}

                                                            
                                                        />
                                                    </div>

                                                    {/* Patient ID Filter */}
                                                    <div style={{ position: 'relative', width: '50%' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            Patient ID
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter patient ID..."
                                                            className={classes.filter_select}
                                                            value={this.state.filterPatientID}
                                                            onChange={(e) => this.handleFilterChange('filterPatientID', e.target.value)}
                                                            style={{
                                                                        cursor: "text",
                                                                        padding: "8px 8px 8px 12px",
                                                                        // width: "100%",
                                                                        border: "1px solid rgb(204, 204, 204)",
                                                                        borderRadius: "4px",
                                                                        fontSize: "14px",
                                                                        backgroundColor: "white",
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Chat Session ID Filter */}
                                                    {/* <div style={{ position: 'relative', width: '50%' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            Chat Session ID
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter chat session ID..."
                                                            className={classes.filter_select}
                                                            value={this.state.filterChatSessionID}
                                                            onChange={(e) => this.handleFilterChange('filterChatSessionID', e.target.value)}
                                                            style={{
                                                                        cursor: "text",
                                                                        padding: "8px 8px 8px 12px",
                                                                        // width: "100%",
                                                                        border: "1px solid rgb(204, 204, 204)",
                                                                        borderRadius: "4px",
                                                                        fontSize: "14px",
                                                                        backgroundColor: "white",
                                                            }}
                                                        />
                                                    </div> */}

                                                    {/* Email Filter */}
                                                    <div style={{ position: 'relative', width: '50%' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            Email
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter email..."
                                                            className={classes.filter_select}
                                                            value={this.state.filterEmail}
                                                            onChange={(e) => this.handleFilterChange('filterEmail', e.target.value)}
                                                            style={{
                                                                        cursor: "text",
                                                                        padding: "8px 8px 8px 12px",
                                                                        // width: "100%",
                                                                        border: "1px solid rgb(204, 204, 204)",
                                                                        borderRadius: "4px",
                                                                        fontSize: "14px",
                                                                        backgroundColor: "white",
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Health Card Number Filter */}
                                                    <div style={{ position: 'relative', width: '50%' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            Health Card Number
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter health card number..."
                                                            className={classes.filter_select}
                                                            value={this.state.filterHealthCard}
                                                            onChange={(e) => this.handleFilterChange('filterHealthCard', e.target.value)}
                                                            style={{
                                                                cursor: "text",
                                                                        padding: "8px 8px 8px 12px",
                                                                        // width: "100%",
                                                                        border: "1px solid rgb(204, 204, 204)",
                                                                        borderRadius: "4px",
                                                                        fontSize: "14px",
                                                                        backgroundColor: "white",
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Interaction Type Filter - Updated options */}
                                                    <div style={{ position: 'relative', width: '50%' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            Interaction Type
                                                        </label>
                                                        <select
                                                            className={classes.filter_select}
                                                            value={this.state.filterInteractionType}
                                                            onChange={(e) => this.handleFilterChange('filterInteractionType', e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            style={{
                                                                cursor: "text",
                                                                        cursor: "text",
                                                                        padding: "8px 8px 8px 12px",
                                                                        width: "100%",
                                                                        border: "1px solid rgb(204, 204, 204)",
                                                                        borderRadius: "4px",
                                                                        fontSize: "14px",
                                                                        backgroundColor: "white",
                                                            }}
                                                        >
                                                            <option value="all">All Types</option>
                                                            <option value="medical_consult">Medical consultation</option>
                                                            <option value="administrative_misc">Administrative Consultation/Misc</option>
                                                            <option value="inactive_chat">Inactive consult</option>
                                                        </select>
                                                    </div>

                                                    {/* Chat Type Filter */}
                                                    <div style={{ position: 'relative', width: '50%' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            Chat Type
                                                        </label>
                                                        <select
                                                            className={classes.filter_select}
                                                            value={this.state.filterChatType}
                                                            onChange={(e) => this.handleFilterChange('filterChatType', e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            style={{
                                                                cursor: "text",
                                                                        padding: "8px 8px 8px 12px",
                                                                        // width: "100%",
                                                                        border: "1px solid rgb(204, 204, 204)",
                                                                        borderRadius: "4px",
                                                                        fontSize: "14px",
                                                                        backgroundColor: "white",
                                                            }}
                                                        >
                                                            <option value="all">All Chat Types</option>
                                                            <option value="physio">Physio Chat</option>
                                                            <option value="family">Family Chat</option>
                                                        </select>
                                                    </div>

                                                    {/* Date Range Inputs */}
                                                    <div style={{ position: 'relative', width: '50%' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            Start Date
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className={classes.filter_select}
                                                            value={this.state.startDate}
                                                            onChange={(e) => this.handleDateChange('startDate', e.target.value)}
                                                            style={{
                                                                cursor: "text",
                                                                        padding: "8px 8px 8px 12px",
                                                                        // width: "100%",
                                                                        border: "1px solid rgb(204, 204, 204)",
                                                                        borderRadius: "4px",
                                                                        fontSize: "14px",
                                                                        backgroundColor: "white",
                                                            }}
                                                        />
                                                    </div>

                                                    <div style={{ position: 'relative', width: '50%' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            fontSize: '12px', 
                                                            fontWeight: '600',
                                                            marginBottom: '4px',
                                                            color: '#555'
                                                        }}>
                                                            End Date
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className={classes.filter_select}
                                                            value={this.state.endDate}
                                                            onChange={(e) => this.handleDateChange('endDate', e.target.value)}
                                                            style={{
                                                                cursor: "text",
                                                                        padding: "8px 8px 8px 12px",
                                                                        // width: "100%",
                                                                        border: "1px solid rgb(204, 204, 204)",
                                                                        borderRadius: "4px",
                                                                        fontSize: "14px",
                                                                        backgroundColor: "white",
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Action Buttons */}
                                                    <div style={{ 
                                                        gridColumn: '1 / -1',
                                                        marginTop: '10px',
                                                        display: 'flex',
                                                        gap: '12px',
                                                        alignItems: 'center'
                                                       }}>
                                                        <button
                                                            onClick={this.applyFilters}
                                                            style={{ 
                                                                cursor: 'pointer',
                                                                padding: '10px 32px',
                                                                backgroundColor: '#28a745',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '4px',
                                                                fontSize: '14px',
                                                                fontWeight: '600',
                                                                transition: 'background-color 0.2s',
                                                                minWidth: '150px'
                                                            }}
                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#218838'}
                                                            onMouseLeave={(e) => e.target.style.backgroundColor = '#28a745'}
                                                        >
                                                            Apply Filters
                                                        </button>
                                                        {hasActiveFilters && (
                                                            <button
                                                                onClick={this.clearAllFilters}
                                                                style={{ 
                                                                    cursor: 'pointer',
                                                                    padding: '10px 24px',
                                                                    backgroundColor: '#dc3545',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    borderRadius: '4px',
                                                                    fontSize: '14px',
                                                                    fontWeight: '500',
                                                                    transition: 'background-color 0.2s',
                                                                    minWidth: '150px'
                                                                }}
                                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
                                                                onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
                                                            >
                                                                Clear All Filters
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {!this.props.loading &&
                                    Boolean(this.props.archives) &&
                                    filteredArchives.length !== 0 && (
                                        <div className={classes.ul_list}>
                                            {archivesList}
                                            {/* Show Load More for filtered results if there's more data */}
                                            {this.state.activeFilters && this.props.hasMoreFiltered && (
                                                <div
                                                    className={classes.load_more}
                                                    onClick={() => this.props.nextFilteredArchives()}
                                                    style={{ marginTop: '20px' }}
                                                >
                                                    Load More
                                                </div>
                                            )}
                                            {/* Hide Load More when filters are active but no more data */}
                                            {!this.props.isSearch && !this.props.isLast && !this.state.activeFilters && (
                                                <div
                                                    className={classes.load_more}
                                                    onClick={() => this.props.nextArchives()}
                                                    style={{ marginTop: '20px' }}
                                                >
                                                    Load More
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {!this.props.loading && filteredArchives.length === 0 && (
                                        <div className={classes.no_text}>No data is found</div>
                                    )}

                                    {this.props.loading && (
                                        <div className={classes.no_loading}>
                                            <div className={classes.no_loading_view}>
                                                <div className={classes.loading_loader}/>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
